import React from "react";
import type { RunwayIndicatorProps } from "./RunwayIndicator.types";

const RunwayIndicator: React.FC<RunwayIndicatorProps> = ({
  runway,
  className = "",
}) => {
  if (runway === Infinity) {
    return null;
  }

  const months = Math.floor(runway);

  let tone: "healthy" | "warning" | "critical" = "healthy";
  if (runway <= 3) tone = "critical";
  else if (runway <= 6) tone = "warning";

  const toneClasses = {
    healthy:
      "border-runway-healthy/40 bg-runway-healthy/10 text-emerald-200",
    warning: "border-runway-warning/40 bg-runway-warning/10 text-amber-100",
    critical: "border-runway-critical/40 bg-runway-critical/10 text-rose-200",
  }[tone];

  return (
    <div
      className={`inline-flex items-center rounded-full border px-4 py-2 text-sm font-semibold ${toneClasses} ${className}`}
    >
      {months} {months === 1 ? "month" : "months"} of runway
    </div>
  );
};

export default RunwayIndicator;
